module.exports = __webpack_public_path__ + "img/aman.e3caac88.jpeg";